var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73062 5.52893C6.68822 6.49664 6 7.95275 6 9.92763C6 11.2166 6.76018 12.8912 7.91015 14.6267C9.03167 16.3192 10.4086 17.9015 11.4054 18.9671C11.7356 19.32 12.2644 19.32 12.5946 18.9671C13.5914 17.9015 14.9683 16.3192 16.0898 14.6267C17.2398 12.8912 18 11.2166 18 9.92763C18 7.95275 17.3118 6.49664 16.2694 5.52893C15.2159 4.55098 13.7222 4 12 4C10.2778 4 8.78405 4.55098 7.73062 5.52893ZM6.36989 4.06319C7.84995 2.68917 9.85619 2 12 2C14.1438 2 16.15 2.68917 17.6301 4.06319C19.1212 5.44746 20 7.45517 20 9.92763C20 11.8482 18.9373 13.9503 17.757 15.7314C16.5483 17.5555 15.0877 19.2297 14.0551 20.3334C12.9345 21.5313 11.0655 21.5313 9.94488 20.3334C8.91232 19.2297 7.45167 17.5555 6.24296 15.7314C5.06271 13.9503 4 11.8482 4 9.92763C4 7.45517 4.87878 5.44746 6.36989 4.06319Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.640e2da265ae3c1dea1908beb05a90ac.svg";
export { ForwardRef as ReactComponent };